// if: lines of code > 300
// then: breakdown this file and move to repoV2/features/OfferingVariationSelector/.utils folder

import { callApi } from "repoV2/utils/common/api/callApi";
import { IEvent } from "@Interfaces/redux/";
import {
    FETCH_OFFERING_VARIATIONS,
    VARIANT_TYPE_IDS,
} from "./OfferingVariationSelector.constants";

export const fetchOfferingVariationsData = (eventUuid: string) => {
    return callApi({
        url: `${FETCH_OFFERING_VARIATIONS}/${eventUuid}`,
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    });
};

export const isDefaultNotSelectedInOfferingVariations = (
    eventData?: IEvent.IEventData
) =>
    eventData?.is_offering_variants_enabled &&
    eventData?.selectedOfferingVariation?.variant_type !==
        VARIANT_TYPE_IDS.default;

export const isListingVariantType = (eventData?: IEvent.IEventData) => {
    return (
        eventData?.selectedOfferingVariation?.variant_type ===
        VARIANT_TYPE_IDS.others
    );
};
